import gql from "graphql-tag";

export const MUTATION_SYNC_FROM_BLAZE = gql`
    mutation syncFromBlaze($account_id: String!, $store_id: String!) {
        syncFromBlaze(account_id: $account_id, store_id: $store_id)
    }
`;
